/** @format */

import { memo } from 'react'

import styles from 'dir/styles/courses.module.css'

export const _1 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>1 - Ванильный CSS</h2>
    <p className={styles.description}>
      CSS3 переходы и анимации это лучший метод для простой анимации, но только в тех случаях, когда над анимируемым
      элементом не выполняются операции удаления и добавления в DOM.{' '}
    </p>
    <p className={styles.description}>
      Использование CSS для скрытия элементов противоречит идеологии React, разметка остается в DOM-дереве, и
      практически невозможно нормально сделать анимацию исчезновения. Анимация добавления и удаления элементов коллекции
      излишне сложная.{' '}
    </p>
    <iframe
      height="300"
      scrolling="no"
      src="https://codesandbox.io/embed/lym153z46z?fontsize=14&hidenavigation=1&theme=dark"
      title="Vanilla CSS transitions"
      frameBorder="no"
      loading="lazy"
      allowTransparency="true"
      allowFullScreen="true"
    />
  </section>
))
